import React, { useState } from 'react';
import axios from 'axios';
import API_BASE from '../api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  // הגענו לכאן כי הסשן פג (הטוקן הישן נדחה) — מסבירים למה, פעם אחת.
  const [sessionExpired] = useState(() => {
    try {
      if (sessionStorage.getItem('ustar_session_expired')) {
        sessionStorage.removeItem('ustar_session_expired');
        return true;
      }
    } catch (e) { /* ignore */ }
    return false;
  });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const { data } = await axios.post(API_BASE + '/auth/login', { username, password });
      if (data.ok) {
        localStorage.setItem('ustar_admin_token', data.token);
        onLogin();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה בהתחברות');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #060e1f 0%, #0a1a3e 50%, #060e1f 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Heebo', sans-serif", direction: 'rtl', padding: 16
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <img src="/ustar-logo.png" alt="USTAR" style={{ height: 80, marginBottom: 16 }}
            onError={e => { e.target.style.display = 'none'; }} />
          <h1 style={{ color: '#d4af37', margin: 0, fontSize: '1.8rem', fontWeight: 700 }}>
            מועדון יוסטאר
          </h1>
          <p style={{ color: '#6a7a9a', margin: '8px 0 0', fontSize: '0.9rem' }}>
            ⭐ מערכת ניהול פנימית
          </p>
        </div>

        {/* Card */}
        <div style={{
          background: '#0d1a35',
          border: '1px solid #2a3a6a',
          borderRadius: 20,
          padding: '36px 32px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
        }}>
          <h2 style={{ color: '#fff', margin: '0 0 28px', fontSize: '1.2rem', fontWeight: 600, textAlign: 'center' }}>
            כניסה למערכת הניהול
          </h2>

          {sessionExpired && (
            <div style={{
              background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.4)',
              borderRadius: 10, padding: '12px 14px', marginBottom: 20,
              color: '#e8c86a', fontSize: '0.88rem', lineHeight: 1.6, textAlign: 'center'
            }}>
              ⏳ הסשן פג — התחבר/י מחדש והכול יחזור.
              <br/>
              <span style={{ color: '#8a9aba', fontSize: '0.82rem' }}>המידע שלך שמור במלואו.</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Username */}
            <div style={{ marginBottom: 16 }}>
              <label style={{ color: '#8a9aba', fontSize: '0.85rem', display: 'block', marginBottom: 6 }}>
                שם משתמש
              </label>
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                autoComplete="username"
                placeholder="הזן שם משתמש"
                style={{
                  width: '100%', padding: '12px 16px', background: '#0a1525',
                  border: '1px solid #2a3a6a', borderRadius: 10, color: '#fff',
                  fontSize: '1rem', outline: 'none', boxSizing: 'border-box',
                  transition: 'border-color 0.2s'
                }}
                onFocus={e => e.target.style.borderColor = '#d4af37'}
                onBlur={e => e.target.style.borderColor = '#2a3a6a'}
              />
            </div>

            {/* Password */}
            <div style={{ marginBottom: 24 }}>
              <label style={{ color: '#8a9aba', fontSize: '0.85rem', display: 'block', marginBottom: 6 }}>
                סיסמה
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                placeholder="הזן סיסמה"
                style={{
                  width: '100%', padding: '12px 16px', background: '#0a1525',
                  border: '1px solid #2a3a6a', borderRadius: 10, color: '#fff',
                  fontSize: '1rem', outline: 'none', boxSizing: 'border-box',
                  transition: 'border-color 0.2s'
                }}
                onFocus={e => e.target.style.borderColor = '#d4af37'}
                onBlur={e => e.target.style.borderColor = '#2a3a6a'}
              />
            </div>

            {/* Error */}
            {error && (
              <div style={{
                background: '#2a0a0a', border: '1px solid #ff6b6b',
                color: '#ff9999', borderRadius: 8, padding: '10px 14px',
                fontSize: '0.88rem', marginBottom: 16, textAlign: 'center'
              }}>
                ❌ {error}
              </div>
            )}

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '14px 0',
                background: loading ? '#5a4a00' : 'linear-gradient(135deg, #d4af37, #f0cc60)',
                color: '#0a1120', border: 'none', borderRadius: 10,
                fontSize: '1.05rem', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'opacity 0.2s', fontFamily: "'Heebo', sans-serif"
              }}
            >
              {loading ? '⏳ מתחבר...' : '🔐 כניסה למערכת'}
            </button>
          </form>
        </div>

        <p style={{ color: '#3a4a6a', textAlign: 'center', fontSize: '0.78rem', marginTop: 24 }}>
          גישה מורשית בלבד • מועדון יוסטאר © 2024
        </p>
      </div>
    </div>
  );
}
